module.exports = __webpack_public_path__ + "static/img/avatar-bar.481603c1.webp";